import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/reset.css';
// import './stylesheets/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheets/App.css';
import './stylesheets/style.css';
import 'es6-promise/auto'

import ScrollToTop from './components/App/ScrollToTop'

import App from './components/App/AppContainer';
import registerServiceWorker from './registerServiceWorker';

import { Provider } from 'react-redux';
import createFinalStore from './store';
// import { Route } from "react-router";
// import { BrowserRouter } from "react-router-dom"
import createHistory from "history/createBrowserHistory";
// import 'font-awesome.min.css'
import NotificationsSystem from 'reapop'
import theme from 'reapop-theme-bootstrap'


import {
  ConnectedRouter
} from "react-router-redux";

//Middleware
// import promiseMiddleware from 'redux-promise';  //非同期処理用
// import { createLogger } from 'redux-logger';    //ログ取得用

//Material-Ui
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from "react-tap-event-plugin";
// import * as SG from './constants/AppSettings'
injectTapEventPlugin(); //タッチイベント実行用

const store = createFinalStore();
const history = createHistory();

ReactDOM.render(
  <MuiThemeProvider>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {/* <BrowserRouter>     */}
        <ScrollToTop>
          <App />
          <NotificationsSystem theme={theme} />
        </ScrollToTop>
        {/* </BrowserRouter> */}
      </ConnectedRouter>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js